export const PAYLOAD_URL = "https://eqfr8wasyk.execute-api.ap-southeast-2.amazonaws.com/beta/scores"
export const API_KEY = 'kmEtk_*!@rGgepnb=Dte5qn+@E9u-xSBTK5J+LuBn6fYsn4ah4';